import {FULFILLED} from 'redux-promise-middleware';
import {call, select, takeEvery} from 'redux-saga/effects';

import {CUSTOMER, LOCATION_CHANGED} from 'constants/actions';
import {CUSTOMER_ID} from 'constants/customer';

import {riskifiedLoad} from 'libs/riskified';
import {sessionStore} from 'libs/storage/storage';
import {waitForCustomer} from 'sagas/analytics/helpers/waitFor';
import {getCustomer} from 'selectors/customer/customer';
import {getLocation} from 'selectors/app/app';

/**
 *  Initialize riskified.
 */
export function* initializeRiskified() {
    yield call(waitForCustomer);
    const {id} = yield select(getCustomer);
    yield call(riskifiedLoad, id);
    yield call([sessionStore, 'set'], CUSTOMER_ID, id);
}

/**
 * Update location.
 */
export function* updateLocation() {
    if (!window.RISKX) return;
    const {location} = yield select(getLocation);
    yield call([window.RISKX, 'go'], location.pathname);
}

/**
 * Update ID.
 */
export function* updateId() {
    if (!window.RISKX) return;
    const storedId = yield call([sessionStore, 'get'], CUSTOMER_ID);
    const {id} = yield select(getCustomer);
    if (id === storedId) return;
    yield call([window.RISKX, 'setSid'], id);
    yield call(updateLocation);
    yield call([sessionStore, 'set'], CUSTOMER_ID, id);
}

/**
 *  Begin of saga.
 */
export default function* riskified() {
    yield call(initializeRiskified);
    yield takeEvery(LOCATION_CHANGED, updateLocation);
    yield takeEvery(`${CUSTOMER.GET_CUSTOMER_DATA}_${FULFILLED}`, updateId);
}
